import type { LoaderData } from '../common/interface';
import { hasAuthToken } from './auth';
import { getLoginRedirectPath, storeRedirectUrl } from './redirectUtils';

/**
 * Redirect to SSO login (when context exists) or /login when the user is not
 * authenticated and the 404 is due to missing auth / portal context — not a
 * genuine missing public page (siteId/tenantId + permalink).
 */
export const shouldRedirectUnauthenticatedNotFoundToLogin = (
  loaderData: LoaderData | null,
  currentState: string,
): boolean => {
  if (currentState !== 'page-not-found') {
    return false;
  }

  if (hasAuthToken()) {
    return false;
  }

  if (loaderData?.siteData) {
    return false;
  }

  const error = loaderData?.error;
  if (error?.type === 'network' && error?.status === 404) {
    return false;
  }

  return true;
};

export const redirectUnauthenticatedUserToLogin = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  storeRedirectUrl();
  const loginPath = getLoginRedirectPath(window.location.search);
  window.location.replace(`${window.location.origin}${loginPath}`);
};
